import { render, staticRenderFns } from "./ResultInputDetail.vue?vue&type=template&id=24bd63d4"
import script from "./ResultInputDetail.vue?vue&type=script&lang=js"
export * from "./ResultInputDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports